/**
 * Messages used when validating block reason. Pass translated strings from the caller.
 */
export type BlockReasonValidationMessages = {
  required: string;
  textOnly: string;
};

/**
 * Pure validation for block reason field.
 * Returns an error message when invalid, or undefined when valid.
 * Caller is responsible for setting/clearing validation state.
 */
export function getBlockReasonValidationError(
  reason: unknown,
  messages: BlockReasonValidationMessages
): string | undefined {
  if (reason == null || (typeof reason === "string" && reason.trim() === "")) {
    return messages.required;
  }
  if (reason != null && typeof reason !== "string") {
    return messages.textOnly;
  }
  return undefined;
}
